import { Play } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { TriggerNodeEditor } from "./editor";
import { TriggerNodePanel } from "./panel";
import { TriggerNodeProps } from "./types";
import { TriggerNodeDataDto } from "@babackapp/private-api-client/types";
import { DEFAULT_TRIGGER_CONFIGS } from "./constants";

const newNodeDefaultValue: TriggerNodeDataDto = {
  triggerType: "tracking_status_change",
  config: DEFAULT_TRIGGER_CONFIGS.tracking_status_change,
};

export default registerNode<TriggerNodeProps["data"]>({
  type: "trigger",
  name: "workflowsEditor.nodes.trigger.title",
  description: "workflowsEditor.nodes.trigger.description",
  Icon: Play,
  category: NodeCategory.TRIGGER,
  color: "blue",
  editor: {
    component: TriggerNodeEditor,
  },
  configPanel: {
    component: TriggerNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export * from "./types";
export { TriggerNodeEditor } from "./editor";
export { TriggerNodePanel } from "./panel";
export {
  useTrackingStatusList,
  useTrackingStatusMap,
  type TrackingStatusOption,
} from "./use-tracking-status-list";
